import React, { useState, useEffect, useRef } from "react";
import { Device } from "@twilio/voice-sdk";
import axios from "axios";
import { GetRequest } from "../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useLocation, useNavigate } from "react-router-dom";
import TwilioIntegrationForm from "./TwilioIntegrationForm";
import { baseURL } from "../../Utils/constants/constant";
const BrowserCall = () => {
  const navigate=useNavigate();
  const location=useLocation();

    const [customer, setCustomer] = useLocalStorageState("customer", {
      token: {},
    });
    const customer_id = customer?.customer_details?.customer_id || 1;
    const token = customer?.token?.authorization || "";
    const rf = customer?.token?.authentication || "";
    const extras = { customer, setCustomer, rf, navigate };
    const headers = {
      Authorization: token,
      Authentication: rf,
    };
    const loginUserId = customer?.customer_details?.id;
  const [device, setDevice] = useState(null);
  const [currentCall, setCurrentCall] = useState(null);
  const [customerNumber, setCustomerNumber] = useState("");
  const [status, setStatus] = useState("Initializing...");
  const [logs, setLogs] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [timer, setTimer] = useState(0);
  const timerInterval = useRef(null);
  const [showIntegrationModal,setShowIntegrationModal]=useState(true)
  const fetchHistory = async () => {
    try {
      const res = await axios.get("http://localhost:5000/voice/history");
      setLogs(res.data);
    } catch (err) {
      console.error("History fetch error");
    }
  };

  // Common Cleanup Logic
  const handleCallEnd = () => {
    setStatus("Call Ended");
    setCurrentCall(null);
    stopTimer();
    setTimeout(() => {
      fetchHistory();
      setStatus("Ready to Call");
    }, 3000);
  };

 

  useEffect(() => {
  let newDevice;

  const initDevice = async () => {
    try {
      const response = await GetRequest(
        `${baseURL}voice/token/${customer_id}`,
        {},
        {}
      );

      newDevice = new Device(response?.token, {
        logLevel: 1,
        edge: "ashburn",
      });

      newDevice.on("registered", () => setStatus("Ready to Call"));

      newDevice.on("tokenWillExpire", async () => {
        console.log("Token expiring... refreshing");

        const res = await GetRequest(
          `${baseURL}voice/token/${customer_id}`,
          {},
          {}
        );

        newDevice.updateToken(res.token);
      });

      newDevice.on("incoming", (call) => {
        console.log("Incoming call:", call.parameters.From);

        setStatus("Incoming Call...");
        setCurrentCall(call);

        const acceptCall = window.confirm(
          `Incoming call from ${call.parameters.From}. Uthana chahte hain?`
        );

        if (acceptCall) {
          call.accept();
          setStatus("On Call...");
          startTimer();
          call.on("disconnect", handleCallEnd);
        } else {
          call.reject();
          handleCallEnd();
        }
      });

      await newDevice.register();
      setDevice(newDevice);
      fetchHistory();

    } catch (err) {
      console.error(err);
      setStatus("Setup Error");
    }
  };

  initDevice();

  return () => {
    if (newDevice) newDevice.destroy();
  };
}, []);
  const startTimer = () => {
    setTimer(0);
    timerInterval.current = setInterval(() => {
      setTimer((prev) => prev + 1);
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(timerInterval.current);
  };

  const handleCall = async () => {
    if (device && customerNumber) {
      setStatus("Dialing...");
      try {
        const call = await device.connect({
          params: {
            To: customerNumber,
            Record: isRecording ? "true" : "false",
            user_login_id:loginUserId,
            customer_id:customer_id,
          },
        });
        setCurrentCall(call);

        call.on("accept", () => {
          setStatus("On Call...");
          startTimer();
        });

        call.on("disconnect", handleCallEnd);
        call.on("reject", handleCallEnd);
      } catch (err) {
        setStatus("Dialing Failed");
      }
    }
  };

  const formatTime = (s) => {
    const mins = Math.floor(s / 60);
    const secs = s % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };


   const handleIntegrationModalClose=()=>{
    navigate(-1)
    setShowIntegrationModal(false)
    
   }
  return (<>
    {showIntegrationModal ?<TwilioIntegrationForm isOpen={showIntegrationModal} onClose={handleIntegrationModalClose} /> :<>
        <div className="container mt-5">
      <style>{`
        .glass-card { background: #ffffff; border-radius: 20px; border: 1px solid #eef2f6; }
        .status-badge { padding: 10px; border-radius: 50px; font-size: 0.8rem; font-weight: bold; text-transform: uppercase; }
        .on-call { background: #dc3545; color: white; animation: pulse 1.5s infinite; }
        @keyframes pulse { 0% { opacity: 1; } 50% { opacity: 0.7; } 100% { opacity: 1; } }
        .ready { background: #e8f5e9; color: #2e7d32; }
        .dialing { background: #fff3e0; color: #ef6c00; }
      `}</style>

      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="glass-card shadow-sm p-4 mb-4 text-center">
            <h5 className="mb-3 fw-bold">Twilio Voice Dialer</h5>
            <div className="d-flex justify-content-center mb-4">
              <span className={`status-badge px-4 ${status === "On Call..." ? "on-call" : status === "Dialing..." ? "dialing" : "ready"}`}>
                {status}
              </span>
            </div>

            {status === "On Call..." && <h1 className="display-4 fw-bold mb-4">{formatTime(timer)}</h1>}

            <div className="input-group mb-3 mx-auto" style={{ maxWidth: "400px" }}>
              <input
                type="text"
                className="form-control form-control-lg text-center shadow-none"
                placeholder="+919876543210"
                value={customerNumber}
                onChange={(e) => setCustomerNumber(e.target.value)}
                disabled={!!currentCall}
              />
            </div>

            {!currentCall && (
              <div className="form-check form-switch d-flex justify-content-center mb-4">
                <input className="form-check-input" type="checkbox" checked={isRecording} onChange={() => setIsRecording(!isRecording)} />
                <label className="form-check-label ms-2 text-muted small">Enable Call Recording</label>
              </div>
            )}

            {currentCall ? (
              <button onClick={() => currentCall.disconnect()} className="btn btn-danger btn-lg px-5 rounded-pill shadow-sm">
                <i className="bi bi-telephone-x-fill me-2"></i> End Call
              </button>
            ) : (
              <button onClick={handleCall} className="btn btn-primary btn-lg px-5 rounded-pill shadow-sm" disabled={status === "Dialing..."}>
                <i className="bi bi-telephone-fill me-2"></i> {status === "Dialing..." ? "Connecting..." : "Start Call"}
              </button>
            )}
          </div>

          <div className="mt-5">
            <h6 className="fw-bold mb-3"><i className="bi bi-clock-history me-2 text-primary"></i>Recent Activity</h6>
            <div className="glass-card shadow-sm overflow-hidden">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="bg-light">
                    <tr className="small text-muted">
                      <th className="ps-4 py-3">PHONE NUMBER</th>
                      <th>STATUS</th>
                      <th>DURATION</th>
                      <th>DATE & TIME</th>
                      <th className="text-center">RECORDING</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.map((log, index) => (
                      <tr key={log.callSid || index}>
                        <td className="ps-4 fw-semibold">
                          {/* Yahan fix kiya hai: Incoming call mein identity ki jagah customer number dikhega */}
                          {log.to === "pug_crm_agent_001" ? log.from : (log.to || "N/A")}
                        </td>
                        <td><span className={`badge rounded-pill px-3 py-2 ${log.status === 'completed' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>{log.status}</span></td>
                        <td>{log.duration}</td>
                        <td className="small text-muted">{log.time}</td>
                        <td className="text-center">
                          {log.recording && log.recording !== "No recording" ? (
                            <a href={log.recording} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary rounded-circle"><i className="bi bi-play-fill"></i></a>
                          ) : "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div></>
    
      
    }</>
  );
};

export default BrowserCall;




